<app-crudbar [label]="title" (onReady)="doComReady($event,'crudbar')" [editAndSaveVisible]="true">
</app-crudbar>
<div>
  <div class="w-full top-10 border-2  bg-gray-100">
    @if(masterVisible){
    <div class="top-1 border-1">
      <app-admpi83 (onFormReady)="doFormReady($event,PageKind.master)">
      </app-admpi83>
    </div>
    }
    <!-- @if(detailVisible){
    <div class="top-1 border-1 border-2 border-green-400">
      <app-admi10-detail (onFormReady)="doFormReady($event,PageKind.detail)">
      </app-admi10-detail>
    </div>
    } -->
  </div>
<div>
